module.exports = __webpack_public_path__ + "static/img/typebg1.a73e876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/typebg1.png
// module id = Ynl8
// module chunks = 8